var _desc, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProgressCardActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "-0.5 -0.5 16 16",
    fill: "currentColor",
    id: "Tag-Chevron-Fill--Streamline-Phosphor-Fill",
    height: 16,
    width: 16,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Tag Chevron Fill Streamline Icon: https://streamlinehq.com")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m14.762701171875 7.791380859375001 -2.99649609375 4.49146875c-0.19439648437499998 0.291357421875 -0.521267578125 0.46660546875 -0.8715175781250001 0.46725585937499997H0.6753515625c-0.404150390625 0.00026367187499999996 -0.657029296875 -0.437080078125 -0.455185546875 -0.78721875 0.005718750000000001 -0.009919921875000001 0.011759765625 -0.019646484375 0.0181171875 -0.029173828125000002L3.194748046875 7.5 0.241564453125 3.0662871093749997C0.01725 2.73009375 0.24099609375000003 2.27715234375 0.644296875 2.2509843750000003c0.010341796875 -0.00066796875 0.0206953125 -0.00103125 0.0310546875 -0.0010898437499999999h10.2193359375c0.35025 0.000650390625 0.6771210937500001 0.17589843749999998 0.8715175781250001 0.46725585937499997l2.99452734375 4.49146875c0.11830078125000001 0.17602734375 0.11908007812500002 0.405943359375 0.00196875 0.58276171875Z",
    strokeWidth: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProgressCardActive);
export default __webpack_public_path__ + "static/media/progress_card_active.4ae7186f4ef4c5a031cdfd29c50ff163.svg";
export { ForwardRef as ReactComponent };